import { LogSafeValue, LogSafeValueImpl } from '@redngapps/shared/logging/types';

import { isLogSafeValue } from './is-log-safe-value';

export function getLogValue(value: LogSafeValue): unknown {
  if (isLogSafeValue(value)) {
    return (value as LogSafeValueImpl).value;
  }

  throw new Error('Provided value must be of type LogSafeValue');
}
